import React, { FC } from 'react';
import Controls from './Controls';
import Labels from './Labels';
import { TitleContainer, SegmentorContainer } from './Segmentor.style';
import { IStudy } from 'models/icardio';

interface IProps {
  activeFrame: any;
  activeSegmentationClass: any;
  activeSegmentation: any;
  dicom: any;
  phaseLabels: any;
  segmentationClasses: any;
  segmentations: any;
  segmentationReferences: any;
  setActiveSegmentationClass: any;
  setActiveFrameIndex: any;
  setActiveSegmentation: any;
  setSegmentation: any;
  useOpenContours: any;
  setUseOpenContours: any;
  showOtherSegmentations: any;
  setShowOtherSegmentations: any;
  showSegmentationPredictions: any;
  showSegmentationReferences: any;
  adoptSegmentation: any;
  study?: IStudy;
  editMode: boolean;
  activeOtherSegmentationClasses: any;
  setActiveOtherSegmentationClasses: any;
}

const Segmentor: FC<IProps> = props => {
  const {
    activeFrame,
    activeSegmentationClass,
    activeSegmentation,
    dicom,
    phaseLabels,
    segmentationClasses,
    segmentations,
    segmentationReferences,
    setActiveSegmentationClass,
    setActiveFrameIndex,
    setActiveSegmentation,
    setSegmentation,
    useOpenContours,
    setUseOpenContours,
    showOtherSegmentations,
    setShowOtherSegmentations,
    showSegmentationPredictions,
    showSegmentationReferences,
    adoptSegmentation,
    study,
    editMode,
    activeOtherSegmentationClasses,
    setActiveOtherSegmentationClasses,
  } = props;
  return (
    <SegmentorContainer>
      <TitleContainer>Segment Dicom</TitleContainer>
      <Labels
        activeFrame={activeFrame}
        activeSegmentationClass={activeSegmentationClass}
        dicom={dicom}
        phaseLabels={phaseLabels}
        segmentationClasses={segmentationClasses}
        setActiveFrameIndex={setActiveFrameIndex}
        setActiveSegmentationClass={setActiveSegmentationClass}
        segmentations={segmentations}
        setSegmentation={setSegmentation}
        study={study}
        segmentationReferences={segmentationReferences}
        activeOtherSegmentationClasses={activeOtherSegmentationClasses}
        setActiveOtherSegmentationClasses={setActiveOtherSegmentationClasses}
      />
      <Controls
        segmentations={segmentations}
        activeSegmentation={activeSegmentation}
        useOpenContours={useOpenContours}
        setUseOpenContours={setUseOpenContours}
        setActiveSegmentation={setActiveSegmentation}
        showOtherSegmentations={showOtherSegmentations}
        setShowOtherSegmentations={setShowOtherSegmentations}
        setActiveOtherSegmentationClasses={setActiveOtherSegmentationClasses}
        showSegmentationPredictions={showSegmentationPredictions}
        showSegmentationReferences={showSegmentationReferences}
        adoptSegmentation={adoptSegmentation}
        editMode={editMode}
      />
    </SegmentorContainer>
  );
};

export default Segmentor;
